<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="12" xl="9">
        <CRow>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3">
            <div class="form-group">
              <label for="datepicker">Từ ngày - đến ngày</label>
              <DatePicker id="datepicker" locale="vi" v-model="dateRange"
                :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }" :popover="{ visibility: 'click' }" is-range
                class="datepicker">
                <template v-slot="{ inputValue, inputEvents }">
                  <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                    class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly />
                </template>
              </DatePicker>
            </div>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
            <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
            <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3">
            <BaseSelect :options="fileTypeSelect.options" :data="fileTypeSelect.data" ref="fileTypeSelect">
            </BaseSelect>
          </CCol>
        </CRow>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="12" xl="3">
        <CRow>
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <div style="margin-top: 10px">
                <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Xuất báo cáo'"
                  class="btn-action-primary" @click="exportSubmit()">
                  <i class="fa fa-download"></i>&nbsp;Xuất báo cáo
                </CButton>
                <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Tải lại'"
                  class="btn-action-primary" @click="loadDataMainTable(true)">
                  <i class="fa fa-refresh"></i>&nbsp;Tải lại
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>

    <CRow class="mt-4">
      <CCol md="12">
        <CCard>
          <CCardHeader color="light">
            <i class="fa fa-file"></i>
            <strong> Số lượng bản tin đã phát theo từng lĩnh vực <span v-if="statistic && statistic"></span></strong>
          </CCardHeader>
          <CCardBody class="row">
            <CDataTable class="custom-scroll" :items="mainTableSummary.items" :fields="mainTableSummary.options.fields"
              :sorter="false" :sorterValue="{ column: null, asc: 'true' }" :clickableRows="false"
              :hover="false" ref="mainTableSummary">
              <template #index="{ index }">
                <td>{{ index + 1 }}</td>
              </template>
              <template slot="no-items-view">
                <span style="color: #969696">Danh sách trống!</span>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>


        <CCard class="content-fade-in mt-3p5">
          <CCardBody>
            <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
              ref="mainTable">
              <template #index="{ index }">
                <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
              </template>
              <template #deviceCode="{ item }">
                <td>
                  <span :key="item.deviceCode" class="badge badge-light">{{
                    item.deviceDescription !== '' && item.deviceDescription != null ? item.deviceDescription :
                    item.deviceCode
                  }}</span>
                </td>
              </template>
              <template #fileTitle="{ item }">
                <td style="font-weight: bold; cursor: pointer">
                  <span>{{ item.fileTitle }}</span>
                </td>
              </template>
              <template #startTime="{ item }">
                <td>
                  {{ $helper.formatDateDDMMYYYYHHMM(item.startTime) }}
                </td>
              </template>
              <template #endTime="{ item }">
                <td>
                  {{ $helper.formatDateDDMMYYYYHHMM(item.endTime) }}
                </td>
              </template>
              <template #locationName="{ item }">
                <td>
                  <span class="badge badge-light">{{ item.locationName }}</span>
                </td>
              </template>
            </BaseTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import { DatePicker } from "v-calendar";
import BaseModal from "@/views/base/BaseModal";
import BaseFormPreview from "@/views/base/BaseFormPreview";

export default {
  name: "Broadcast",
  components: {
    BaseFormPreview,
    BaseModal,
    BaseFormLoading,
    BaseTable,
    BaseInput,
    BaseSelect,
    DatePicker,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    return {
      loading: { value: false },
      loadingPreview: { value: false },
      dateRange: {
        start: that.$helper.subtractNowDate(30),
        end: new Date()
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      fileTypeSelect: {
        options: {
          filter: true,
          label: "Lĩnh vực <span class='required'>*</span>",
          selectAllText: "Tất cả lĩnh vực",
        },
        data: {
          name: "fileTypeId",
          items: [],
          model: "",
          source: {
            url: '/common/listFileType',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.fileTypeSelect.data.items = dataResponse.data;
            }
          },
        }
      },
      statistic: '',

      mainTableSummary: {
        options: {
          fields: [
            { key: "index", label: "STT", sorter: false, filter: false },
            { key: "name", label: "Lĩnh vực" },
            { key: "total", label: "Số lượng bản tin" },
          ],
          slots: ["index", "name", "total"],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
        },
        items: [],
      },

      mainTable: {
        options: {
          fields: [
            { key: "index", label: "STT", sorter: false, filter: false },
            { key: "startTime", label: "Thời gian bắt đầu" },
            { key: "endTime", label: "Thời gian kết thúc" },
            { key: "fileTitle", label: "Nội dung phát" },
            { key: "deviceCode", label: "Thiết bị" },
            { key: "typeName", label: "Lĩnh vực" },
            { key: "locationName", label: "Địa bàn thiết bị" },
          ],
          slots: [
            "index",
            "startTime",
            "endTime",
            "locationName",
            "deviceCode",
          ],
          lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false,
          sorter: true,
          columnFilter: false,
          pageSize: 20,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
        },
        dataSource: {
          url: "/report/file-broadcast",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            params.locationCode = that.locationCode.data.model,
              params.fileTypeId = that.fileTypeSelect.data.model
            return params;
          },
          response: function (dataResponse) {
            that.mainTableSummary.items = dataResponse.data.summary;
            return dataResponse.data.details;
          },
        },
      },
      hlsPreview: '',
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    exportSubmit() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/exports/fileBroadcast",
        dataSubmit: function () {
          var params = that.$helper.setupDataSubmit(that.$data);
          params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
          params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
          params.locationCode = that.locationCode.data.model,
            params.fileTypeId = that.fileTypeSelect.data.model
          return params;
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
          } else {
            that.$helper.fetchAndDownloadByURI(response.data.data.path, response.data.data.name);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date(),
          end: new Date()
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        // this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        // this.wardCodeInput.options.disabled = false;
      } else {
        // this.wardCodeInput.data.items = [];
        // this.wardCodeInput.options.disabled = true;
      }
      this.$refs.wardCodeInput.loadData();
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
    'fileTypeSelect.data.model': function (value) {
      this.loadDataMainTable();
    },
  },
  computed: {},
};
</script>
<style scoped>
.preview {
  cursor: pointer;
  color: rgba(0, 0, 255, 0.85);
  font-weight: 500;
  font-size: 15px;
}

.preview:hover {
  text-decoration: underline;
}
</style>
